import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LegalPageComponent } from './page/legal-page/legal-page.component';

const routes: Routes = [
  {
    path: 'terminos',
    component: LegalPageComponent,
    title: 'Términos y Condiciones — Convivia',
    data: { docId: 'terminos', pageTitle: 'Términos y Condiciones de Uso', navigation: { solidNavigation: true } },
  },
  {
    path: 'privacidad',
    component: LegalPageComponent,
    title: 'Política de Privacidad — Convivia',
    data: {
      docId: 'privacidad',
      pageTitle: 'Política de Tratamiento de Información Personal',
      navigation: { solidNavigation: true },
    },
  },
  {
    path: '**',
    redirectTo: 'terminos',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes), LegalPageComponent],
})
export class LegalModule {}
